import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calcFileSizeInKb',
  standalone: false
})
export class CalcFileSizeInKbPipe implements PipeTransform {

  transform(sizeInBytes: number): string {
    return (sizeInBytes / 1024).toFixed(0) + ' KB';
  }

}
